<template>
  <div class="container-card">
    <h3 class="role">{{ information?.role }}</h3>
    <h4 class="company">{{ information?.company }}</h4>
    <p>
      <small>{{ information?.period }}</small>
    </p>
    <p>
      <small>{{ information?.location }}</small>
    </p>
  </div>
</template>

<script>
export default {
  name: "CardExperience",
  props: {
    information: {
      required: true,
      type: Object,
    },
  },
};
</script>

<style scoped>
.container-card {
  color: var(--color-text);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.container-card + .container-card {
  margin-top: 1.875rem;
}

.role {
  font-family: "Montserrat";
  font-size: var(--fs-text-1);
  color: var(--color-text);
  margin-bottom: 0.625rem;
  text-align: center;
}

.company {
  color: var(--color-text);
  font-family: "Raleway";
  font-size: var(--fs-text-2);
  transition: 0.1s color;
  line-height: 1.4;
}

p {
  font-family: "Raleway";
}
</style>
